import { faExclamationTriangle } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { CardEmptyState, EmptyStateIcon } from 'components/atoms/empty-state';

const ErrorMessage = ({ onErrorRefresh }) => (
  <>
    <FormattedMessage id="project.overview.card.error" />{' '}
    <LinkButton onClick={onErrorRefresh}>
      <FormattedMessage id="retry" />
    </LinkButton>
  </>
);

export const ErrorContent: FC<{ onErrorRefresh?(): void }> = ({
  onErrorRefresh,
}) => {
  return (
    <CardEmptyState
      image={<EmptyStateIcon icon={faExclamationTriangle} />}
      message={<ErrorMessage onErrorRefresh={onErrorRefresh} />}
    />
  );
};
